import React from "react";
import {
  Filter,
  TextInput,
  TabbedForm,
  FormTab,
  ImageInput,
  ImageField,
  List,
  Edit,
  NumberInput,
  Create,
  Datagrid,
  EditButton,
  ReferenceInput,
  Toolbar,
  SaveButton,
  Button,
  Link,
  SelectInput,
  TextField,
  ReferenceField,
  Tab,
  ReferenceManyField,
  DateField,
  BooleanInput,
  FormDataConsumer
} from "react-admin";
import withStyles from "@material-ui/core/styles/withStyles";
import { isNil } from "ramda";

import MotorCycle from "@material-ui/icons/Motorcycle";
import Money from "@material-ui/icons/Money";

const imageStyles = {
  row: {
    display: "flex",
    width: "100%",
    gap: "16px",
    marginTop: "8px",
    alignItems: "stretch"
  },
  column: {
    flex: "1 1 0",
    minWidth: 0,
    border: "1px solid #e0e0e0",
    borderRadius: 4,
    padding: 12,
    boxSizing: "border-box",
    "& label": { display: "none" }
  },
  title: {
    margin: "0 0 8px",
    fontSize: "0.95rem",
    fontWeight: 500
  },
  frame: {
    height: 160,
    background: "#fafafa",
    border: "1px dashed #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12,
    overflow: "hidden"
  },
  img: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain"
  },
  empty: {
    color: "#999",
    fontSize: "0.85rem"
  },
  upload: { width: "100%" },
  drop: {
    background: "#efefef",
    cursor: "pointer",
    padding: "12px 8px",
    textAlign: "center",
    color: "#666",
    minHeight: 72
  }
};

const ImageColumn = withStyles(imageStyles)(
  ({ classes, record, title, imageSource, inputSource }) => {
    const image = record && record[imageSource];
    return (
      <div className={classes.column}>
        <p className={classes.title}>{title}</p>
        <div className={classes.frame}>
          {!isNil(image) ? (
            <img src={image} alt={title} className={classes.img} />
          ) : (
            <span className={classes.empty}>No image</span>
          )}
        </div>
        <ImageInput
          source={inputSource}
          label=" "
          accept="image/*"
          multiple={true}
          classes={{ root: classes.upload, dropZone: classes.drop }}
          placeholder={<span>Drop an image here, or click to select</span>}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </div>
    );
  }
);

const VehicleModelFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);

export const VehicleModelList = props => (
  <List
    {...props}
    resource="vehicle_models"
    filters={<VehicleModelFilter />}
    sort={{ field: "order", order: "ASC" }}
    perPage={50}
    bulkActionButtons={false}
  >
    {/* sort={{ field: 'order', order: 'ASC' }}>  */}
    <Datagrid>
      <TextField label="ID" source="id" />
      <TextField label="Model Name" source="model_name" />
      <TextField label="Screen Order" source="order" />
      <ReferenceField
        label="Type"
        source="vehicle_type_id"
        reference="vehicle_types"
        linkType={false}
        allowEmpty={true}
      >
        <TextField source="vehicle_type" />
      </ReferenceField>
      <ReferenceField
        label="Category"
        source="vehicle_category_id"
        reference="vehicle_categories"
        linkType={false}
        allowEmpty={true}
      >
        <TextField source="vehicle_category" />
      </ReferenceField>
      <EditButton />
    </Datagrid>
  </List>
);

const VehicleModelTitleCreate = object => (
  <span>{" Create Vehicle Model "}</span>
);

const CustomEditButton = object => {
  const link = `/rental_prices/${object.record.id}`;
  return (
    <EditButton
      to={{
        pathname: link,
        search: `?vm=${object.record.price_item_id}`
      }}
      label="Edit"
    />
  );
};

const VehicleModelTitle = object => (
  <span>
    {" Edit Vehicle Model "} &quot;{`${object.record.model_name}`}&quot;
  </span>
);

const VehicleEditBar = (props, classes, className) => (
  <Toolbar {...props}>
    <SaveButton />
    <Button
      component={Link}
      to={{
        pathname: `/vehicle_models`
      }}
      label="Back to models"
    >
      <MotorCycle />
    </Button>
  </Toolbar>
);

const AddNewPricesButton = object => {
  return (
    <Button
      component={Link}
      to={{
        pathname: "/rental_prices/create",
        search: `?vm=${object.record.id}&vmt=${object.record.model_name}`
      }}
      label="Add Prices"
    >
      <Money />
    </Button>
  );
};

export const VehicleModelEdit = ({ classes, ...props }) => (
  <Edit title={<VehicleModelTitle />} {...props}>
    <TabbedForm
      enctype="multipart/form-data"
      method="post"
      toolbar={<VehicleEditBar props={{ ...props }} />}
    >
      <FormTab label="General Data">
        <ReferenceInput
          label="Category"
          source="vehicle_category_id"
          reference="vehicle_categories"
          allowEmpty
        >
          <SelectInput source="id" optionText="vehicle_category" />
        </ReferenceInput>
        <ReferenceInput
          label="Type"
          source="vehicle_type_id"
          reference="vehicle_types"
          allowEmpty
        >
          <SelectInput source="id" optionText="vehicle_type" />
        </ReferenceInput>
        <TextInput label="Model" source="model_name" />
        <TextInput label="Model Year" source="model_year" />
        <NumberInput label="Order" source="order" />
        <NumberInput label="Displacement (cc)" source="displacement" />
        <NumberInput label="Horse Power (hp)" source="horse_power" />
        <NumberInput label="Gas Tank (lt)" source="gas_tank" />
        <BooleanInput label="Hidden in booking" source="hidden_in_booking" />
        <FormDataConsumer fullWidth>
          {({ formData }) => (
            <div style={imageStyles.row}>
             {/*  <ImageColumn
                record={formData}
                title="Model image"
                imageSource="image_url"
                inputSource="files"
              /> */}
              <ImageColumn
                record={formData}
                title="Left image (L)"
                imageSource="left_image_url"
                inputSource="files_l"
              />
              <ImageColumn
                record={formData}
                title="Right image (R)"
                imageSource="right_image_url"
                inputSource="files_r"
              />
            </div>
          )}
        </FormDataConsumer>
      </FormTab>
      <FormTab label="Vehicle Specs (En)">
        <TextInput label="Engine Type" source="engine_type_en" />
        <TextInput label="Luggage System" source="luggage_system_en" />
        <TextInput label="Final Drive" source="final_drive_en" />
        <TextInput label="Seat Height" source="seat_height_en" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_en"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (Es)">
        <TextInput label="Engine Type" source="engine_type_es" />
        <TextInput label="Luggage System" source="luggage_system_es" />
        <TextInput label="Final Drive" source="final_drive_es" />
        <TextInput label="Seat Height" source="seat_height_es" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_es"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (De)">
        <TextInput label="Engine Type" source="engine_type_de" />
        <TextInput label="Luggage System" source="luggage_system_de" />
        <TextInput label="Final Drive" source="final_drive_de" />
        <TextInput label="Seat Height" source="seat_height_de" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_de"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (Pt)">
        <TextInput label="Engine Type" source="engine_type_pt" />
        <TextInput label="Luggage System" source="luggage_system_pt" />
        <TextInput label="Final Drive" source="final_drive_pt" />
        <TextInput label="Seat Height" source="seat_height_pt" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_pt"
        />
      </FormTab>
      <FormTab label="Rental Prices For Model">
        <Tab label="Prices" path="prices">
          <ReferenceManyField
            addLabel={false}
            reference="prices"
            target="price_item_id"
            sort={{ field: "start_date", order: "DESC" }}
            filter={{ price_item_type: 'vehicle_model' }}
          >
            <Datagrid>
              <DateField source="start_date" />
              <TextField source="price" />
              <TextField source="days_interval_1" />
              <TextField source="days_interval_2" />
              <CustomEditButton />
            </Datagrid>
          </ReferenceManyField>
          <AddNewPricesButton />
        </Tab>
      </FormTab>
    </TabbedForm>
  </Edit>
);

export const VehicleModelCreate = ({ classes, ...props }) => (
  <Create title={<VehicleModelTitleCreate />} {...props}>
    <TabbedForm>
      <FormTab label="General Data">
        <ReferenceInput
          label="Category"
          source="vehicle_category_id"
          reference="vehicle_categories"
          allowEmpty
        >
          <SelectInput source="id" optionText="vehicle_category" />
        </ReferenceInput>
        <ReferenceInput
          label="Type"
          source="vehicle_type_id"
          reference="vehicle_types"
          allowEmpty
        >
          <SelectInput source="id" optionText="vehicle_type" />
        </ReferenceInput>
        <TextInput label="Model" source="model_name" />
        <TextInput label="Model Year" source="model_year" />
        <NumberInput label="Order" source="order" />
        <NumberInput label="Displacement (cc)" source="displacement" />
        <NumberInput label="Horse Power (hp)" source="horse_power" />
        <NumberInput label="Gas Tank (lt)" source="gas_tank" />
        <BooleanInput label="Hidden in booking" source="hidden_in_booking" />
        <ImageInput
          source="files"
          label="Model Image"
          accept="image/*"
          multiple={true}
        >
          <ImageField source="model_image" title="Model Image" />
        </ImageInput>
      </FormTab>
      <FormTab label="Vehicle Specs (En)">
        <TextInput label="Engine Type" source="engine_type_en" />
        <TextInput label="Luggage System" source="luggage_system_en" />
        <TextInput label="Final Drive" source="final_drive_en" />
        <TextInput label="Seat Height" source="seat_height_en" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_en"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (Es)">
        <TextInput label="Engine Type" source="engine_type_es" />
        <TextInput label="Luggage System" source="luggage_system_es" />
        <TextInput label="Final Drive" source="final_drive_es" />
        <TextInput label="Seat Height" source="seat_height_es" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_es"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (De)">
        <TextInput label="Engine Type" source="engine_type_de" />
        <TextInput label="Luggage System" source="luggage_system_de" />
        <TextInput label="Final Drive" source="final_drive_de" />
        <TextInput label="Seat Height" source="seat_height_de" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_de"
        />
      </FormTab>
      <FormTab label="Vehicle Specs (Pt)">
        <TextInput label="Engine Type" source="engine_type_pt" />
        <TextInput label="Luggage System" source="luggage_system_pt" />
        <TextInput label="Final Drive" source="final_drive_pt" />
        <TextInput label="Seat Height" source="seat_height_pt" />
        <TextInput
          label='Other Features (separated by ",")'
          source="other_features_pt"
        />
      </FormTab>
    </TabbedForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/vehicleModels.js